import React from 'react';
import { Box } from '@mui/material';

import { Text } from 'ui';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  divider?: boolean;
}

export const DetailRow: React.FC<DetailRowProps> = ({ label, value, divider = false }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 1,
      px: 2,
      borderTop: divider ? '1px solid' : 'none',
      borderTopColor: 'divider'
    }}
  >
    <Text content={label} type="body2" />
    <Box sx={{ textAlign: 'right' }}>{value}</Box>
  </Box>
);
